import bindAll from "lodash.bindall";
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import React from "react";
import styles from "./versionUpdate.module.css";
import {closeVersionUpdateModal} from "../../redux/actions/modelsActive.js"

class VersionUpdate extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={styles.versionApear}>
                <div className={styles.versionInfoContainer}>



                    <div className={styles.versionClose} onClick={this.props.closeVersionUpdateModal}></div>

                    <div className={styles.versionTitle}>{`${'11.0.2'}版本上线了!`}</div>
                    <div className={styles.versionContent}>
                        <div className={styles.versionContentText}>{''}</div>
                    </div>
                    <a href={''} download={''} className={styles.versionUpdateButton}>立即更新</a>
                </div>
            </div>
        );
    }
}
VersionUpdate.propTypes = {
    isRtl: PropTypes.bool,
    onTryIt: PropTypes.func,
    onViewProject: PropTypes.func
};

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
    closeVersionUpdateModal:()=>dispatch(closeVersionUpdateModal())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VersionUpdate);
